ConnectStore = require 'components/enhancers/connect_store'
{ gdtDataToNmaData, nmaDataToVizData } = require 'lib/nma_helper'
mediator = require 'mediator'
Modal = require 'components/common/modal'
NMAVizActions = require 'actions/nma_viz_actions'
NMAVizStore = require 'stores/nma_viz_store'
Router = require 'router'
Spinner = require 'components/common/spinner'
{
  CommonComparatorTableWithI18n
  ForestPlotWithI18n
  NetworkGraphWithI18n
  SidebarButton
  SidebarWithI18n
  TableSettingsContext
} = NmaComponents
{ useCoffeeCallback, useCoffeeMemo } = require 'lib/react_utils'
{ useState } = React

ID_CONNECTOR = '#'

getRowId = (rowData) -> _.compact([rowData.rowElement?.id, rowData.comparator?.id]).join(ID_CONNECTOR)

storeConnector =
  NMAVizStore: (Store) ->
    forestPlotOutcomeId: Store.getForestPlotOutcomeId()
    isFetching: Store.isFetching()
    isNetworkGraphOpen: Store.isNetworkGraphOpen()
    outcomes: Store.getOutcomes()
    question: Store.getQuestion()
    vizConfig: Store.getVizConfig().toJS()

NMAViz = ({
  forestPlotOutcomeId
  isFetching
  isNetworkGraphOpen
  outcomes: outcomesFromStore
  question
  vizConfig
}) ->
  [isSidebarOpen, setIsSidebarOpen] = useState false
  [expandedRows, setExpandedRows] = useState []

  {
    comparatorId
    comparatorTableMode,
    denominator,
    outcomes,
    renderMode,
    interventionComparisonPairs,
    selectedInterventionIds,
    selectedOutcomeIds,
    tableOrder,
    transposed
  } = vizConfig

  onExpand = useCoffeeCallback [expandedRows], (rowId) ->
    setExpandedRows (prev) ->
      if rowId in prev
        prev.filter (id) -> id isnt rowId
      else
        prev.concat rowId

  { interventions, comparisons, outcomes, explanations } = useCoffeeMemo [outcomesFromStore, question], ->
    gdtDataToNmaData question, outcomesFromStore

  outcomesToPass = useCoffeeMemo [outcomes, selectedOutcomeIds], ->
    outcomes.filter (outcome) -> selectedOutcomeIds.includes outcome.id

  openSidebar = useCoffeeCallback [], ->
    setIsSidebarOpen true

  closeSidebar = useCoffeeCallback [], ->
    setIsSidebarOpen false

  openLeagueTable = useCoffeeCallback [question], (outcomeId) ->
    route = Router::getProjectRelativeUrl "/nma/#{question.get('_id')}/outcomes/#{outcomeId}"
    mediator.publish '!router:route', route

  data = useCoffeeMemo [comparatorId, comparisons, interventions, selectedInterventionIds, comparatorTableMode, interventionComparisonPairs], ->
    selectedInterventions = interventions.filter (intervention) ->
      selectedInterventionIds.includes intervention.id
    nmaDataToVizData interventions, selectedInterventions, interventionComparisonPairs, comparisons, comparatorId, comparatorTableMode

  networkGraphData = useCoffeeMemo [outcomesFromStore, question], ->
    gdtDataToNmaData question, outcomesFromStore

  tableOrder = if _.every(tableOrder, _.isEmpty)
    {
      interventionRowsOrder: data.map(getRowId)
      outcomeRowsOrder: outcomesToPass.map((value) -> value.id)
      columnOrder: outcomesToPass.map((value) -> value.id)
    }
  else
    tableOrder

  setInterventionComparisonPairs = useCoffeeCallback [], (pairs) ->
    NMAVizActions.updateVizConfig({ field: 'interventionComparisonPairs', value: pairs })

  setComparatorTableMode = useCoffeeCallback [], (value) ->
    NMAVizActions.updateVizConfig({ field: 'comparatorTableMode', value })

  return <Spinner /> if isFetching

  <div className="nma-viz">
    <TableSettingsContext.Provider value={_.extend({}, vizConfig, {
      outcomes: outcomesToPass
      thresholdType: question.get('thresholdOptions')
    })}>
      <CommonComparatorTableWithI18n
        comparatorTableMode={comparatorTableMode}
        data={data}
        expandedRows={expandedRows}
        expandDetails={onExpand}
        explanations={explanations}
        forestPlotSelected={NMAVizActions.openForestPlot}
        i18nInstance={i18next}
        leagueTableSelected={openLeagueTable}
        outcomes={outcomesToPass}
        showCoeInsufficientLabel={mediator.services.switches.isServerSwitchOn('acpFeatures')}
        tableOrder={tableOrder}
        setTableOrder={NMAVizActions.setTableOrder}
        transposed={transposed}
        thresholdType={question.get('thresholdOptions')}
      />
      <SidebarWithI18n
        comparatorId={comparatorId}
        comparatorTableMode={comparatorTableMode}
        denominator={denominator}
        i18nInstance={i18next}
        interventionComparisonPairs={interventionComparisonPairs}
        interventions={interventions}
        isVisible={isSidebarOpen}
        onComparatorChange={NMAVizActions.selectComparator}
        onDenominatorChange={NMAVizActions.selectDenominator}
        onHide={closeSidebar}
        onInterventionComparisonPairsChange={setInterventionComparisonPairs}
        onSelectedInterventionsChange={NMAVizActions.selectInterventionIds}
        onSelectedOutcomesChange={NMAVizActions.selectOutcomeIds}
        onToggleTransposed={NMAVizActions.toggleTransposed}
        outcomes={outcomes}
        selectedInterventions={selectedInterventionIds}
        selectedOutcomes={selectedOutcomeIds}
        setComparatorTableMode={setComparatorTableMode}
        setSymbolsInsteadOfLettersAsFootnote={NMAVizActions.setSymbolsInsteadOfLettersAsFootnote}
        thresholdType={question.get('thresholdOptions')}
        toggleCertaintyIcons={NMAVizActions.toggleCertaintyIcons}
        toggleHighlights={NMAVizActions.toggleHighlights}
        toggleThresholds={NMAVizActions.toggleThresholds}
      />
      {forestPlotOutcomeId? and <Modal
        className="nma-viz-plot"
        closeButton
        isOpen
        onClose={NMAVizActions.closeForestPlot}
      >
        <ForestPlotWithI18n
          comparisonName={interventions.find(({ id }) -> id is comparatorId).name}
          data={data}
          i18nInstance={i18next}
          outcome={outcomes.find ({ id }) -> id is forestPlotOutcomeId}
        />
      </Modal>}
      {isNetworkGraphOpen and <Modal
        className="nma-viz-plot"
        closeButton
        isOpen
        onClose={NMAVizActions.closeNetworkGraph}
      >
        <NetworkGraphWithI18n data={networkGraphData} i18nInstance={i18next} />
      </Modal>}

    </TableSettingsContext.Provider>
    <span className="nma-viz__sidebar-button">
      <SidebarButton onClick={openSidebar} />
    </span>
  </div>

NMAViz.propTypes =
  forestPlotOutcomeId: PropTypes.string,
  isNetworkGraphOpen: PropTypes.bool.isRequired
  isFetching: PropTypes.bool.isRequired
  outcomes: PropTypes.instanceOf(Immutable.List).isRequired
  question: PropTypes.instanceOf(Immutable.Map).isRequired
  vizConfig: PropTypes.object.isRequired

NMAViz.defaultProps =
  forestPlotOutcomeId: null

module.exports = ConnectStore NMAViz, NMAVizStore, storeConnector
